export var WebStorageType = /*#__PURE__*/function (WebStorageType) {
  WebStorageType["LocalStorage"] = "localStorage";
  WebStorageType["SessionStorage"] = "sessionStorage";
  return WebStorageType;
}({});